/*
 * Broadcast Theme - Referrer popup
 */

(function() {

  // ====== Config: per domein eigen tekst ======
  // Voeg hier brands toe / pas de teksten aan
  var brandConfigs = [
    {
      id: 'pomme',
      domain: 'pommedejus.nl',
      title: 'Welkom klant van Pomme de Jus',
      body: 'Je vindt jouw favoriete items voortaan bij <strong>Le Fanfare</strong> 🎉',
      url: '/collections/pomme-de-jus'
    },
    {
      id: 'bonbon',
      domain: 'bonbonontheblock.com',
      title: 'Welkom klant van BonBon on the Block',
      body: 'Je vindt jouw favoriete items voortaan bij <strong>Le Fanfare</strong> 🎉',
      url: '/pages/bonbon-on-the-block'
    },
    {
      id: 'saartjeprum',
      domain: 'saartjeprum.nl',
      title: 'Welkom klant van Saartje Prum',
      body: 'We hebben jouw vertrouwde collectie verhuisd naar <strong>Le Fanfare</strong>. Leuk dat je er bent! 🙌',
      url: '/collections/saartje-prum'
        }
    // 👉 Hier kun je extra brands/domainregels toevoegen
  ];

  // ====== Cookie helpers ======
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    var n = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(n) === 0) {
        return c.substring(n.length);
      }
    }
    return null;
  }

  // ====== Hoofdlogica ======
  document.addEventListener('DOMContentLoaded', function() {
    var ref = document.referrer || '';

    // Testmodus: ?referrer=pommedejus.nl of ?referrer=voorbeeldmerk.nl
    var urlParams = new URLSearchParams(window.location.search);
    var testRef = urlParams.get('referrer');
    if (testRef) {
      ref = testRef;
    }

    // Bepaal welke brand-config hoort bij deze referrer
    var activeBrand = getBrandFromRef(ref);

    if (!activeBrand) {
      return; // geen passende brand gevonden → geen popup
    }

    var cookieName = 'welcome_from_' + activeBrand.id;
    var alreadyShown = getCookie(cookieName);

    if (!alreadyShown) {
      setCookie(cookieName, '1', 7); // 7 dagen niet opnieuw tonen
      showWelcomePopup(activeBrand);
    }
  });

  // Zoek in brandConfigs welke domain matcht met referrer string
  function getBrandFromRef(ref) {
    if (!ref) return null;
    for (var i = 0; i < brandConfigs.length; i++) {
      if (ref.indexOf(brandConfigs[i].domain) !== -1) {
        return brandConfigs[i];
      }
    }
    return null;
  }

  // Bouw de popup op basis van de gekozen brand
  function showWelcomePopup(brand) {
    var popup = document.createElement('div');
    popup.className = 'brand-welcome-popup';
    popup.innerHTML = `
      <div class="brand-welcome-popup__backdrop"></div>
      <div class="brand-welcome-popup__content">
        <button class="brand-welcome-popup__close" aria-label="Sluiten">&times;</button>
        <h4>${brand.title}</h4>
        <p>${brand.body}</p>
        <p>We hebben de collectie meeverhuisd. Voel je vrij om rond te kijken!</p>
        <br/>
        <center>
        <button type="button" class="btn btn--black btn--medium btn--solid" data-popup-open="">
        <a class="brandwelcomelink" href="${brand.url}">Klik hier om de collectie te zien!</a>
        </button>
        </center>
      </div>
    `;

    document.body.appendChild(popup);

    popup.querySelector('.brand-welcome-popup__close')
      .addEventListener('click', function() { popup.remove(); });

    popup.querySelector('.brand-welcome-popup__backdrop')
      .addEventListener('click', function() { popup.remove(); });
  }

})();
